export default __webpack_public_path__ + "static/media/funfinder-spot.ab62d76d.png";